import { ctxRoutes } from '@/contexts/RoutesCtx';
import { LatLngExpression } from 'leaflet';
import { useContext, useEffect, useState } from 'react';
import { Polyline } from 'react-leaflet';

export function RoutePolyline({
  positions,
  isHighlighted,
  handleClick,
}: {
  positions: LatLngExpression[];
  isHighlighted: boolean;
  handleClick: () => void;
}) {
  const routesCtx = useContext(ctxRoutes);
  const [forceKey, setForceKey] = useState(0);

  useEffect(() => {
    setForceKey((prev) => prev + 1);
  }, [routesCtx?.highlightedRoutes]);

  return (
    <>
      <Polyline
        positions={positions}
        weight={20}
        color="transparent"
        interactive={true}
        eventHandlers={{
          click: handleClick,
        }}
      />
      {isHighlighted ? (
        <Polyline
          key={forceKey}
          positions={positions}
          stroke
          weight={6}
          color="#FF1414"
          opacity={1}
          interactive={false}
          className="normal-line"
          pane="highlightPane"
        />
      ) : (
        <Polyline key={forceKey} positions={positions} stroke weight={6} color="#BBB" opacity={1} interactive={false} />
      )}
    </>
  );
}
